import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'

import { configRenderSuccess } from '../../../../redux/actions'
// import { uiConstants } from '../../../../constants/ui.constants'

// const applyProps = (key, val) => {
//   document.documentElement.style.setProperty(`--${key}`, val)
// }

const Render = ({ config }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (config.loading && config.settings && !config.render) {
      if (config.settings.css) {
        var counter = 0

        config.settings.css.forEach((css) => {
          const s = document.createElement('link')
          s.rel = 'stylesheet'
          s.href = css
          s.crossOrigin = 'anonymous'
          s.referrerPolicy = 'no-referrer'
          document.head.append(s)
          s.onload = () => {
            counter++
          }
          s.onerror = () => {
            counter++
          }
        })
      }

      const ti = setInterval(() => {
        if (config.settings.css.length === counter) {
          dispatch(configRenderSuccess())
          clearInterval(ti)
        }
      }, 10)
    }
  }, [config.loading, config.render, config.settings, dispatch])

  return <React.Fragment />
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {})(Render)
